import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDolbyComponent } from './simple-icons-dolby.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDolbyComponent ],
    exports:      [ SimpleIconsDolbyComponent ],
    bootstrap:    []
})
export class SimpleIconsDolbyModule {}
